const linkToContact = '/dashboard/contact/';
const linkToCustomer = '/dashboard/customer/';
const linkToDeal = '/dashboard/deal/';
const linkToTicket = '/dashboard/ticket/';

export function findAssociatedMajorEntity(planningEntity) {
  let majorEntity = {
    id: undefined,
    label: undefined,
    name: undefined,
    linkTo: undefined,
  };

  if (planningEntity['contact']) {
    majorEntity.id = planningEntity['contact']['id'];
    majorEntity.label = 'Contact';
    majorEntity.name =
      planningEntity['contact']['name'] +
      ' ' +
      planningEntity['contact']['lastname'];
    majorEntity.linkTo = linkToContact;
  } else if (planningEntity['customer']) {
    majorEntity.id = planningEntity['customer']['id'];
    majorEntity.label = 'Client';
    majorEntity.name =
      planningEntity['customer']['installationSite']['socialReason'];
    majorEntity.linkTo = linkToCustomer;
  } else if (planningEntity['deal']) {
    majorEntity.id = planningEntity['deal']['id'];
    majorEntity.label = 'Affaire';
    majorEntity.name = planningEntity['deal']['name'];
    majorEntity.linkTo = linkToDeal;
  } else if (planningEntity['ticket']) {
    majorEntity.id = planningEntity['ticket']['id'];
    majorEntity.label = 'Ticket';
    majorEntity.name = planningEntity['ticket']['subject'];
    majorEntity.linkTo = linkToTicket;
  } else {
    majorEntity = undefined;
  }

  return majorEntity;
}

export function appendGraphQlPlanning() {
  return 'tasks{ id, title, criticity, priority, state, closed, deadline, creator{ id, firstname, lastname } }, appointments{ id, title, dateMeeting, criticity, priority, state, closed, creator{ id, firstname, lastname } }, reminders{ id, title, dateRecall, criticity, priority, state, closed, creator{ id, firstname, lastname } }, notes{ id, title, dateCreate, creator{ id, firstname, lastname } }';
}

export function appendGraphQlMajorEntity() {
  return 'contact{ id, name, lastname}, customer{ id, installationSite{ socialReason } }, deal{ id, name }, ticket{ id, subject }';
}
